import styled from 'styled-components';

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;

  @media (max-width: ${(p) => p.theme.breakpoints.sm}) {
    max-width: 767px;
  }
`;

export const SearchStyled = styled.div<{ $isActive?: boolean }>`
  position: relative;
  padding-left: 36px;
  height: 40px;
  border: 1px solid
    ${(p) => (p.$isActive ? p.theme.colors.primary : p.theme.colors.black)};
  background: ${(p) =>
    p.$isActive ? p.theme.colors.white : p.theme.colors.secondary};
  border-radius: 5px;
  transition: all 0.2s;

  @media (max-width: ${(p) => p.theme.breakpoints.sm}) {
    background: ${(p) => p.theme.colors.white};
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInput = styled.input`
  display: block;
  width: 100%;
  height: 100%;
  padding: 12px 0;
  color: ${(p) => p.theme.colors.black};
  font-size: 14px;
  font-weight: 400;
  border: none;
  outline: none;
  background: transparent;
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
